export default __webpack_public_path__ + "static/media/menu-leaderboard.d1c257a4.png";